export default __webpack_public_path__ + "static/media/GalleryFirstBlurFullSize.5058f8ad.png";